import gql from 'graphql-tag';
import {
  DISTRIBUTOR_ORDER_FRAGMENT,
  DISTRIBUTOR_STATISTICS_FRAGMENT,
} from '../fragments/distributorCenter';

/**
 * 分销中心数据
 */
export const fetchDistributorCenterDocument = gql`
  query distributorCenter($startDateTime: DateTime, $endDateTime: DateTime) {
    distributorCenter(startDateTime: $startDateTime, endDateTime: $endDateTime) {
      todayDistributor {
        ...DistributorStatistics
      }
      totalDistributor {
        ...DistributorStatistics
      }
      distributor {
        name
        phone
        customer {
          customFields {
            headPortrait
          }
        }
        distributorGroup {
          name
        }
      }
    }
  }
  ${DISTRIBUTOR_STATISTICS_FRAGMENT}
`;

/**
 * 分销中心-业绩统计
 */
export const fetchDistributorPerformanceDocument = gql`
  query distributorPerformance($startDateTime: DateTime, $endDateTime: DateTime) {
    distributorPerformance(startDateTime: $startDateTime, endDateTime: $endDateTime) {
      ...DistributorStatistics
    }
  }
  ${DISTRIBUTOR_STATISTICS_FRAGMENT}
`;

/**
 * 分销中心-推广订单
 */
export const fetchDistributorsPromoteOrdersDocument = gql`
  query distributorsPromoteOrders(
    $customerId: ID
    $search: String
    $startDateTime: DateTime
    $endDateTime: DateTime
    $options: DistributorOrderListOptions
  ) {
    distributorsPromoteOrders(
      customerId: $customerId
      search: $search
      startDateTime: $startDateTime
      endDateTime: $endDateTime
      options: $options
    ) {
      items {
        ...DistributorOrder
      }
      totalItems
    }
  }
  ${DISTRIBUTOR_ORDER_FRAGMENT}
`;

/**
 * 分销中心-推广商品
 */
export const fetchDistributorShareProductsDocument = gql`
  query distributorShareProducts(
    $search: String
    $startDateTime: DateTime
    $endDateTime: DateTime
    $options: DistributorProductRecordListOptions
  ) {
    distributorShareProducts(
      search: $search
      startDateTime: $startDateTime
      endDateTime: $endDateTime
      options: $options
    ) {
      items {
        id
        createdAt
        updatedAt
        product {
          name
          featuredAsset {
            source
          }
        }
        productStatistics {
          productId
          visitorsCount
          pageViews
          addCartPeopleCount
          addCartCount
          numberOfPayers
          conversionRateOfSingleProduct
          numberOfPaidItems
          paymentAmount
          numberOfRefundItems
          numberOfSuccessfulRefunds
          numberOfSuccessfulRefundOrders
          numberOfSuccessfulRefundPeople
        }
      }
      totalItems
    }
  }
`;

/**
 * 分销员点赚添加推广商品
 */
export const fetchAddDistributorShareProductDocumenet = gql`
  mutation addDistributorShareProduct($productId: ID!) {
    addDistributorShareProduct(productId: $productId) {
      id
    }
  }
`;

/**
 * 分销中心-分销员下的用户信息数据
 */
export const fetchDistributorBindingCustomersDocument = gql`
  query distributorBindingCustomers(
    $customerType: CustomerType
    $search: String
    $startDateTime: DateTime
    $endDateTime: DateTime
    $options: DistributorBindingListOptions
  ) {
    distributorBindingCustomers(
      customerType: $customerType
      search: $search
      startDateTime: $startDateTime
      endDateTime: $endDateTime
      options: $options
    ) {
      items {
        id
        createdAt
        updatedAt
        orderTotal
        distributor {
          id
        }
        customer {
          id
          phoneNumber
          isMember
          customFields {
            headPortrait
            isModified
            distributor {
              id
            }
          }
          isDistributor
          lastName
        }
        orderTotalAmount
        lastOrderTime
        perCustomerTransaction
        distributorCustomerRemark
      }
      totalItems
    }
  }
`;

/**
 * 分销中心-分销员下的用户详情接口数据
 */
export const fetchDistributorBindingCustomerDetailDocument = gql`
  query distributorBindingCustomerDetail($customerId: ID!) {
    distributorBindingCustomerDetail(customerId: $customerId) {
      id
      createdAt
      updatedAt
      orderTotal
      customer {
        id
        phoneNumber
        isMember
        customFields {
          headPortrait
        }
      }
      orderTotalAmount
      lastOrderTime
      perCustomerTransaction
      distributorCustomerRemark
    }
  }
`;

/**
 * 分销中心-分销员下的用户详情设置备注
 */
export const fetchSetDistributorBindingRemarkDocument = gql`
  mutation setDistributorBindingRemark($customerId: ID!, $remark: String!) {
    setDistributorBindingRemark(customerId: $customerId, remark: $remark) {
      id
      distributorCustomerRemark
    }
  }
`;

/**
 * 分销中心-查询新增开卡用户
 */
export const fetchDistributorBindingMembersDocument = gql`
  query distributorBindingMembers(
    $search: String
    $startDateTime: DateTime
    $endDateTime: DateTime
    $state: MemberStateInput
    $skip: Int
    $take: Int
  ) {
    distributorBindingMembers(
      search: $search
      startDateTime: $startDateTime
      endDateTime: $endDateTime
      state: $state
      skip: $skip
      take: $take
    ) {
      items {
        memberId
        renewalCount
        membershipPlanName
        customerName
        customerPhone
        customerHeadPortrait
        maturityAt
        state
        maturityType
        isModified
      }
      totalItems
    }
  }
`;
